export default {
  methods: {
    /**
     * 统一处理 tab 页操作
     * 路由跳转，并同步 store 中 pageTab 数据
     *
     * @param {*} obj
     */
    addNav(obj) {
      this.$router.push({
        path: obj.path,
        query: obj.query,
      });
      this.$store.commit('addTab', obj);
    },
  },
};
